/* eslint-disable no-underscore-dangle */
import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized, Params, UrlSegment } from '@angular/router';
import { Location } from '@angular/common';
import {
    HisUiService, HisAuthService, HisNotificationService, HisBaseGlobalsService, HisGlobalDataService,
    HisGenericValueService, GenericValue, DynamicComponent
} from 'hisng';

import { DynamicContentService } from 'app/fs/res/common/service/dynamic-content/dynamic-content.service';
import { DynamicFormGroupUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-form-group-utils';
import { DynamicContentUtils } from '../../../common/service/dynamic-content/dynamic-content-utils';
import { ResTabMenuItem } from 'app/fs/res/common/model/core/tab-menu-item';

import { DATA_SERVICE_KEY_INFRASTRUCTURE } from 'app/fs/res/research-infrastructure/model/constants';
import { ResearchInfrastructureService } from 'app/fs/res/research-infrastructure/service/research-infrastructure.service';
import { ResearchInfrastructure } from 'app/fs/res/research-infrastructure/model/research-infrastructure';
import { ResearchInfrastructureEmployment } from '../../model/research-infrastructure-classes';
import { ResearchInfrastructureModuleOptions } from '../../research-infrastructure-module.options';

@Component({
    selector: 'res-research-infrastructure-edit-form',
    templateUrl: './research-infrastructure-edit-form.component.html',
})

export class ResearchInfrastructureEditFormComponent implements OnInit, AfterContentChecked {

    public readonly moduleOptions = ResearchInfrastructureModuleOptions;

    public researchInfrastructure: ResearchInfrastructure = new ResearchInfrastructure();
    public selectedIndex = 0;
    public usageTypes: GenericValue[];
    public tabMenuItems: ResTabMenuItem[];
    public reloadTrigger = true;
    public showBackButton = false;
    public showSearchButton = false;

    private readonly LOCAL_STORAGE_TAB_INDEX = 'res_researchInfrastructure_tab_index';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private location: Location,
        public auth: HisAuthService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private globalDataService: HisGlobalDataService,
        private researchInfrastructureService: ResearchInfrastructureService,
        private dynamicContentService: DynamicContentService,
        private dynamicContentUtils: DynamicContentUtils,
        private dynamicFormGroupUtils: DynamicFormGroupUtils,
        private genericValueService: HisGenericValueService) {
    }

    ngAfterContentChecked() {
        // dynamic content is only accessible with module 'HISINONERES'
        if (!this.hisBaseGlobalsService.isAnyModuleActive('HISINONERES')) {
            this.researchInfrastructure._dynamicComponent = null;
        }
        this.dynamicContentUtils.setupDynamicTabsHeader(this.researchInfrastructure._dynamicComponent, this.tabMenuItems);
    }

    ngOnInit() {
        this.initializeTabMenuItems();

        this.route.url.subscribe( ( u: UrlSegment[] ) => {
            this.route.queryParams.subscribe( ( queryParams: any ) => {
                this.showBackButton = queryParams.showBackButton ? queryParams.showBackButton === 'true' : this.showBackButton;
                this.showSearchButton = queryParams.showSearchButton ? queryParams.showSearchButton === 'true' : this.showSearchButton;
            } );
            this.route.params.subscribe( (params: Params) => {
                if (this.router.routerState.snapshot.url.includes('edit')) {
                    if (params.id) {
                        this.researchInfrastructure.id = Number.parseInt(params.id, 10);
                        console.log('Test Auth Service', this.auth);
                    }
                }
                if (this.router.routerState.snapshot.url.includes('create')) {
                    this.generateDynamicContent();
                }

                // pre-load usage types to render #dynamicFieldSetContainer via ngFor
                this.genericValueService.getValueTypes('researchInfrastructureUsageTypeValue').subscribe(
                    (dt: GenericValue[]) => {
                        this.usageTypes = dt;
                    });
            });

            this.router.events.subscribe( (event: any) => {
                // type Event or RouterEvent would not compile, see https://github.com/angular/angular/issues/43124
                if (event instanceof RoutesRecognized) {
                    let rr = event as RoutesRecognized;
                    if (rr.state.url.includes('researchinfrastructure/search') || rr.state.url.includes('submenu')) {
                        this.globalDataService.removeData(DATA_SERVICE_KEY_INFRASTRUCTURE);
                    }
                }
            });
        });

        if (this.researchInfrastructure.id) {
            if (!this.infrastructureCachedInGlobalDataService()) {
                this.researchInfrastructureService.getResearchInfrastructureById(this.researchInfrastructure.id).subscribe(
                    (researchInfrastructure: ResearchInfrastructure) => {
                        this.researchInfrastructure = researchInfrastructure;

                        console.log('THIS RESEARCHINFRASTRUCTURE: ', this.researchInfrastructure);
                    });
            }
        } else {
            this.infrastructureCachedInGlobalDataService();
        }
    }

    // button methods ######################################################################
    public saveResearchinfrastructure() {
        // set project dynamic component object values
        this.dynamicFormGroupUtils.setDynamicComponentObject(this.researchInfrastructure);
        console.log('researchInfrastructure._dynamicComponent before save =', this.researchInfrastructure._dynamicComponent);

        this.researchInfrastructureService.saveResearchInfrastructure(this.researchInfrastructure)
            .subscribe( ( savedResearchInfrastructure: ResearchInfrastructure ) => {
                this.researchInfrastructure = savedResearchInfrastructure;
                if (this.researchInfrastructure.id) {
                    // fullTimePercentage for at least on entry in emplyoments less than 1 info message
                    if( this.researchInfrastructure.researchInfrastructureEmployments.find(
                        ( employment: ResearchInfrastructureEmployment ) => employment.fullTimePercentage <= 1 ) ) {
                        this.notificationService.infoI18n( 'fs.res.researchinfrastructure.fullTimePercentage.info' );
                    }
                    this.notificationService.successI18n('fs.res.researchinfrastructure.save.success');
                    this.location.replaceState(
                        `/researchInfrastructure/edit/${this.researchInfrastructure.id}?showBackButton=${this.showBackButton}`
                        + `&showSearchButton=${this.showSearchButton}` );
                }
            });
    }

    public reset() {
        if (this.researchInfrastructure.id) {
            this.researchInfrastructureService.getResearchInfrastructureById(this.researchInfrastructure.id).subscribe(
                (researchInfrastructure: ResearchInfrastructure) => {
                    this.researchInfrastructure = researchInfrastructure;
                });
        } else {
            this.researchInfrastructure = new ResearchInfrastructure();
            this.generateDynamicContent();
        }
        this.globalDataService.removeData(DATA_SERVICE_KEY_INFRASTRUCTURE);
    }

    private generateDynamicContent() {
        this.dynamicContentService.generateDynamicContent('researchInfrastructure', null).subscribe(
            (dC: DynamicComponent) => {
                this.researchInfrastructure._dynamicComponent = dC;
                this.reloadTrigger = !this.reloadTrigger; // reload trigger for dynamicComponent
            });
    }

    /**
     * callback EventEmitter implementation to save this.project
     * to global-data-service - page leave navigation
     */
    public onRouterContextChange() {
        this.dynamicFormGroupUtils.setDynamicComponentObject(this.researchInfrastructure);
        this.globalDataService.setData(DATA_SERVICE_KEY_INFRASTRUCTURE, this.researchInfrastructure);
        localStorage.setItem(this.LOCAL_STORAGE_TAB_INDEX, JSON.stringify(this.selectedIndex)); // remember current tab
    }

    /* handle selected tab change event */
    public onTabIndexChange(event: { index: number }) {
        this.selectedIndex = event.index;
    }

    /*
     * check if journal was cached in globalDataService.
     */
    private infrastructureCachedInGlobalDataService(): boolean {
        let storageTabIndex = JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_TAB_INDEX));
        let dataServiceInfrastructure: ResearchInfrastructure = this.globalDataService.getData(DATA_SERVICE_KEY_INFRASTRUCTURE, true);
        // console.log('DEBUG::DEBUG::', dataServiceInfrastructure);
        if (dataServiceInfrastructure && dataServiceInfrastructure.id === this.researchInfrastructure.id) {
            // set timeout to wait for component tabs rendered
            setTimeout(() => { this.researchInfrastructure = dataServiceInfrastructure; }, 200);
            this.globalDataService.removeData(DATA_SERVICE_KEY_INFRASTRUCTURE);

            this.selectedIndex = storageTabIndex == null ? 0 : storageTabIndex;
            localStorage.removeItem(this.LOCAL_STORAGE_TAB_INDEX);
            return true;
        }
        return false;
    }

    /* initialize default tab menu items */
    private initializeTabMenuItems() {
        this.tabMenuItems = [
            { i18nKey: 'fs.res.common.mainData' },
            { i18nKey: 'fs.res.researchInfrastructure.ResearchInfrastructure.usage' },
            { i18nKey: 'fs.res.common.research' },
        ];
    }

}
